import { z } from "zod";
import { OperationStatusSchema } from "./common.ts";

/**
 * Comma-separated list in a query string -> validated array.
 *
 * The audit table's faceted filters are multi-select ("show me failed and
 * cancelled"), which a single `?status=` value can't express. Empty
 * segments are dropped so `?status=` and a cleared filter both mean
 * "no filter" rather than "match the empty string".
 */
function csv<T extends string>(item: z.ZodType<T, string>) {
	return z
		.string()
		.transform((raw) =>
			raw
				.split(",")
				.map((part) => part.trim())
				.filter((part) => part.length > 0),
		)
		.pipe(z.array(item).min(1))
		.optional();
}

export const OperationSortFieldSchema = z.enum(["startedAt", "finishedAt"]);
export type OperationSortField = z.infer<typeof OperationSortFieldSchema>;

export const OperationListQuerySchema = z.object({
	page: z.coerce.number().int().min(1).default(1),
	pageSize: z.coerce.number().int().min(1).max(100).default(25),
	kind: csv(z.string().min(1)),
	status: csv(OperationStatusSchema),
	sort: OperationSortFieldSchema.default("startedAt"),
	order: z.enum(["asc", "desc"]).default("desc"),
});
export type OperationListQuery = z.infer<typeof OperationListQuerySchema>;
